var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterLifeService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 54,
    viewBox: "0 0 140 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_343_4124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 54
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 53.6759,
    fill: "url(#paint0_radial_343_4124)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_343_4124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9679 37.5517H45.3198L46.151 33.3H47.9679V37.5517Z",
    fill: "#898B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5639 20.133H46.9084L47.747 15.8739H49.5639V20.133Z",
    fill: "#898B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3161 31.9172H4.02321C3.42738 31.9172 2.94189 32.4027 2.94189 32.9985V33.7194H18.404L19.3161 31.9172Z",
    fill: "#3C3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2656 31.9172L19.3608 33.7194H30.9905L30.0857 31.9172H20.2656Z",
    fill: "#3C3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0317 33.7194V32.9985C43.0317 32.4027 42.5462 31.9172 41.9503 31.9172H31.0342L31.939 33.712H43.0317V33.7194Z",
    fill: "#3C3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1817 33.7929C13.4171 33.7929 13.6084 33.9841 13.6084 34.2195V34.5653H41.6196V34.2195C41.6196 33.9841 41.8109 33.7929 42.0463 33.7929C42.2817 33.7929 42.4729 33.9841 42.4729 34.2195V34.5653H43.3189C43.5542 34.5653 43.7455 34.374 43.7455 34.1386C43.7455 33.9032 43.5542 33.712 43.3189 33.712H43.032H31.9393L32.057 33.9474C32.16 34.1533 32.0717 34.4108 31.8657 34.5138C31.6598 34.6168 31.4023 34.5285 31.2993 34.3225L30.9904 33.7046H19.3607L19.0517 34.3225C18.9487 34.5285 18.6913 34.6168 18.4853 34.5138C18.2794 34.4108 18.1911 34.1533 18.2941 33.9474L18.4118 33.712H2.9423H2.93494C2.69955 33.712 2.5083 33.9032 2.5083 34.1386C2.5083 34.374 2.69955 34.5653 2.93494 34.5653H12.7551V34.2195C12.7551 33.9841 12.9463 33.7929 13.1817 33.7929Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3188 37.5518C43.5542 37.5518 43.7455 37.3605 43.7455 37.1251C43.7455 36.8897 43.5542 36.6985 43.3188 36.6985H42.4729V37.5518H43.3188Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25901 36.7868C4.45026 36.647 4.71507 36.6911 4.85484 36.875L5.32561 37.5518H12.7624V36.6985H2.93494C2.69955 36.6985 2.5083 36.8897 2.5083 37.1251C2.5083 37.3605 2.69955 37.5518 2.93494 37.5518H4.28843L4.17073 37.3752C4.03097 37.1913 4.06775 36.9265 4.25901 36.7868Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1236 36.7868C33.3149 36.647 33.5797 36.6911 33.7194 36.875L34.1902 37.5518H41.627V36.6985H13.6084V37.5518H33.153L33.0353 37.3752C32.8956 37.1913 32.9324 36.9265 33.1236 36.7868Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5718 50.6968C13.4762 50.7041 13.3879 50.7188 13.2923 50.7409H13.285C13.2776 50.7409 13.2703 50.7483 13.2555 50.7483C13.2188 50.7556 13.182 50.7703 13.1452 50.785C13.1084 50.7998 13.0716 50.8145 13.0349 50.8292C13.0275 50.8292 13.0202 50.8365 13.0128 50.8365C12.8289 50.9322 12.6671 51.0572 12.5347 51.219L12.5273 51.2264C12.4685 51.2926 12.4243 51.3735 12.3802 51.4471C12.3802 51.4544 12.3728 51.4544 12.3728 51.4618C12.3434 51.5206 12.314 51.5868 12.2919 51.653C12.2919 51.653 12.2919 51.6604 12.2846 51.6604C12.2404 51.7781 12.2184 51.8958 12.2036 52.0208C12.1963 52.0723 12.1963 52.1238 12.1963 52.1753C12.1963 52.9992 12.8436 53.6686 13.638 53.6686C14.4398 53.6686 15.0798 52.9992 15.0798 52.1753C15.0798 51.3514 14.4325 50.6821 13.638 50.6821C13.6307 50.6821 13.616 50.6821 13.6086 50.6821C13.6013 50.6968 13.5866 50.6968 13.5718 50.6968ZM14.4178 52.19C14.4178 52.6314 14.072 52.9845 13.6528 52.9845C13.2261 52.9845 12.8877 52.6314 12.8877 52.19C12.8877 51.7487 13.2335 51.3956 13.6528 51.3956C14.072 51.3956 14.4178 51.7487 14.4178 52.19Z",
    fill: "#382847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8801 52.19C12.8801 52.6314 13.2259 52.9845 13.6451 52.9845C14.0718 52.9845 14.4102 52.6314 14.4102 52.19C14.4102 51.7487 14.0644 51.3956 13.6451 51.3956C13.2185 51.3956 12.8801 51.7487 12.8801 52.19ZM14.0791 52.19C14.0791 52.4328 13.8879 52.6314 13.6451 52.6314C13.4098 52.6314 13.2111 52.4328 13.2111 52.19C13.2111 51.9473 13.4024 51.7487 13.6451 51.7487C13.8805 51.7487 14.0791 51.9473 14.0791 52.19Z",
    fill: "#BBB3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2185 52.19C13.2185 52.4328 13.4098 52.6314 13.6525 52.6314C13.8879 52.6314 14.0865 52.4328 14.0865 52.19C14.0865 51.9473 13.8952 51.7487 13.6525 51.7487C13.4098 51.7487 13.2185 51.9473 13.2185 52.19Z",
    fill: "#A19B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6082 34.5653V34.2196C13.6082 33.9842 13.4169 33.7929 13.1815 33.7929C12.9461 33.7929 12.7549 33.9842 12.7549 34.2196V34.5653V36.7059V37.5592V41.9506C12.8799 41.8771 13.0271 41.8256 13.1815 41.8256C13.336 41.8256 13.4831 41.8697 13.6082 41.9506V37.5592V36.7059V34.5653Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7549 43.3188V48.2914L13.564 49.4536C13.5787 49.4757 13.5935 49.5051 13.6082 49.5272V43.3115C13.4831 43.385 13.336 43.4365 13.1815 43.4365C13.0271 43.4439 12.8799 43.3997 12.7549 43.3188Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7549 49.7846V49.8509H12.799L12.7549 49.7846Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.476 50.0495C13.2848 50.1892 13.0199 50.1451 12.8802 49.9612L12.7993 49.8435H12.7551H11.5929C11.3575 49.8435 11.1663 50.0347 11.1663 50.2701C11.1663 50.5055 11.3575 50.6968 11.5929 50.6968H12.8802H13.6452H14.7707C15.006 50.6968 15.1973 50.5055 15.1973 50.2701C15.1973 50.0347 15.006 49.8435 14.7707 49.8435H13.6231C13.5937 49.9244 13.5422 49.998 13.476 50.0495Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84159 42.6347L5.32547 37.5591L4.85469 36.8824C4.71493 36.6911 4.45011 36.6543 4.25886 36.7941C4.06761 36.9339 4.03083 37.1987 4.17059 37.3899L4.28828 37.5665L8.12807 43.1202C8.25312 42.8333 8.52528 42.6421 8.84159 42.6347Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7551 48.2914L9.60674 43.7528C9.48904 44.0323 9.23159 44.2236 8.91528 44.2456L12.7477 49.7846L12.7918 49.8435L12.8728 49.9612C13.0125 50.1524 13.2773 50.1892 13.4686 50.0494C13.5421 49.9979 13.5936 49.9244 13.6157 49.8435C13.6525 49.7405 13.6451 49.6301 13.601 49.5272C13.5863 49.5051 13.5716 49.4757 13.5569 49.4536L12.7551 48.2914Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5094 50.6968C42.5021 50.6968 42.4873 50.6968 42.48 50.6968C42.4653 50.6968 42.4506 50.6968 42.4359 50.6968C42.3402 50.7041 42.2446 50.7188 42.1563 50.7409H42.149C42.1343 50.7409 42.1269 50.7483 42.1122 50.7483C42.0975 50.7483 42.0901 50.7556 42.0754 50.7556C42.0607 50.763 42.0533 50.763 42.0386 50.7703C42.0313 50.7703 42.0166 50.7777 42.0092 50.7777C41.9798 50.7924 41.943 50.8071 41.9136 50.8145C41.8915 50.8218 41.8694 50.8365 41.8474 50.8512C41.8253 50.866 41.7959 50.8807 41.7738 50.8954C41.7665 50.8954 41.7665 50.9027 41.7591 50.9027C41.7003 50.9395 41.6488 50.9763 41.5973 51.0204L41.5899 51.0278C41.5826 51.0351 41.5752 51.0425 41.5679 51.0499C41.5531 51.0572 41.5458 51.0719 41.5311 51.0793C41.4869 51.1234 41.4428 51.1676 41.3987 51.219L41.3913 51.2264C41.3325 51.2926 41.2883 51.3735 41.2442 51.4471C41.2442 51.4544 41.2368 51.4544 41.2368 51.4618C41.2074 51.5206 41.178 51.5868 41.1559 51.653C41.1559 51.653 41.1559 51.6604 41.1486 51.6604C41.1191 51.7413 41.0971 51.8296 41.0824 51.9179C41.075 51.9473 41.075 51.9841 41.0677 52.0208C41.0603 52.0723 41.0603 52.1238 41.0603 52.1753C41.0603 52.4328 41.1265 52.6755 41.2368 52.8888C41.2589 52.933 41.281 52.9698 41.3104 53.0139C41.3251 53.036 41.3398 53.0507 41.3472 53.0727C41.3766 53.1095 41.406 53.1463 41.4355 53.1831C41.4943 53.2566 41.5679 53.3155 41.6414 53.3743C41.6782 53.4038 41.715 53.4332 41.7591 53.4552C41.7959 53.4773 41.84 53.5067 41.8842 53.5214C41.9283 53.5435 41.9724 53.5582 42.0166 53.5803C42.0607 53.595 42.1048 53.6097 42.149 53.6244C42.2152 53.6391 42.2887 53.6539 42.3623 53.6612C42.4138 53.6686 42.4579 53.6686 42.5094 53.6686C43.3112 53.6686 43.9512 52.9992 43.9512 52.1753C43.9585 51.3662 43.3112 50.6968 42.5094 50.6968ZM42.5094 52.9845C42.0828 52.9845 41.7444 52.6314 41.7444 52.19C41.7444 51.7487 42.0901 51.3956 42.5094 51.3956C42.9361 51.3956 43.2744 51.7487 43.2744 52.19C43.2818 52.624 42.9361 52.9845 42.5094 52.9845Z",
    fill: "#382847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5099 51.3956C42.0832 51.3956 41.7449 51.7487 41.7449 52.19C41.7449 52.6314 42.0906 52.9845 42.5099 52.9845C42.9365 52.9845 43.2749 52.6314 43.2749 52.19C43.2823 51.7487 42.9365 51.3956 42.5099 51.3956ZM42.5099 52.6314C42.2745 52.6314 42.0759 52.4328 42.0759 52.19C42.0759 51.9473 42.2671 51.7487 42.5099 51.7487C42.7453 51.7487 42.9439 51.9473 42.9439 52.19C42.9439 52.4328 42.7453 52.6314 42.5099 52.6314Z",
    fill: "#BBB3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5097 51.7487C42.2743 51.7487 42.0757 51.9473 42.0757 52.19C42.0757 52.4328 42.2669 52.6314 42.5097 52.6314C42.7451 52.6314 42.9437 52.4328 42.9437 52.19C42.9437 51.9473 42.7451 51.7487 42.5097 51.7487Z",
    fill: "#A19B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6194 49.7846V49.8509H41.6635L41.6194 49.7846Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6194 43.3556V48.2914L42.4285 49.4536C42.4432 49.4757 42.458 49.5051 42.4727 49.5272V43.2747C42.3403 43.3776 42.1711 43.4365 41.9872 43.4365C41.8548 43.4438 41.7297 43.4071 41.6194 43.3556Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.046 33.7929C41.8106 33.7929 41.6194 33.9842 41.6194 34.2196V34.5653V36.7059V37.5592V41.9138C41.7297 41.855 41.8548 41.8256 41.9872 41.8256C42.1711 41.8256 42.3403 41.8844 42.4727 41.9874V37.5518V36.6985V34.5579V34.2122C42.4727 33.9842 42.2814 33.7929 42.046 33.7929Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5097 50.6968H43.6352C43.8705 50.6968 44.0618 50.5055 44.0618 50.2701C44.0618 50.0347 43.8705 49.8435 43.6352 49.8435H42.4876C42.4582 49.9244 42.4067 49.998 42.3405 50.0495C42.1493 50.1892 41.8844 50.1451 41.7447 49.9612L41.6638 49.8435H41.6196H40.4574C40.222 49.8435 40.0308 50.0347 40.0308 50.2701C40.0308 50.5055 40.222 50.6968 40.4574 50.6968H41.7447H42.5097Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6696 42.6347C37.6843 42.6347 37.6916 42.6347 37.7063 42.6347L34.1902 37.5518L33.7194 36.875C33.5797 36.6838 33.3149 36.647 33.1236 36.7868C32.9324 36.9265 32.8956 37.1913 33.0353 37.3826L33.153 37.5591L36.9634 43.0613C37.0958 42.8039 37.3606 42.6347 37.6696 42.6347Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7446 49.9612C41.8844 50.1524 42.1492 50.1892 42.3404 50.0494C42.414 49.998 42.4655 49.9244 42.4876 49.8435C42.5243 49.7405 42.517 49.6302 42.4729 49.5272C42.4581 49.5051 42.4434 49.4757 42.4287 49.4536L41.6196 48.2914L38.4345 43.694C38.3388 43.9808 38.0887 44.2015 37.7798 44.2383L41.6196 49.7846L41.6637 49.8435L41.7446 49.9612Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7551 41.9433C12.527 42.083 12.3726 42.3405 12.3726 42.6274C12.3726 42.9142 12.527 43.1717 12.7551 43.3114C12.8801 43.385 13.0272 43.4365 13.1817 43.4365C13.3362 43.4365 13.4833 43.3924 13.6084 43.3114C13.8364 43.1717 13.9909 42.9142 13.9909 42.6274C13.9909 42.3405 13.8364 42.083 13.6084 41.9433C13.4833 41.8697 13.3362 41.8182 13.1817 41.8182C13.0272 41.8256 12.8801 41.8697 12.7551 41.9433ZM13.5789 42.6347C13.5789 42.8554 13.4024 43.0319 13.1817 43.0319C12.961 43.0319 12.7845 42.8554 12.7845 42.6347C12.7845 42.414 12.961 42.2375 13.1817 42.2375C13.4024 42.2375 13.5789 42.414 13.5789 42.6347Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7844 42.635C12.7844 42.8558 12.9611 43.0324 13.1819 43.0324C13.4027 43.0324 13.5794 42.8558 13.5794 42.635C13.5794 42.4141 13.4027 42.2375 13.1819 42.2375C12.9611 42.2375 12.7844 42.4141 12.7844 42.635Z",
    fill: "#C78031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61389 43.7528C9.65067 43.6572 9.67274 43.5542 9.67274 43.4439C9.67274 42.9951 9.3123 42.6347 8.86359 42.6347C8.85624 42.6347 8.84888 42.6347 8.83417 42.6347C8.51786 42.6421 8.25305 42.8333 8.128 43.1055C8.08387 43.2085 8.05444 43.3188 8.05444 43.4439C8.05444 43.8926 8.41488 44.253 8.86359 44.253C8.88566 44.253 8.90037 44.253 8.92244 44.253C9.23139 44.2236 9.4962 44.025 9.61389 43.7528ZM8.86359 43.8411C8.64292 43.8411 8.46637 43.6645 8.46637 43.4439C8.46637 43.2232 8.64292 43.0466 8.86359 43.0466C9.08427 43.0466 9.26081 43.2232 9.26081 43.4439C9.26081 43.6645 9.08427 43.8411 8.86359 43.8411Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86404 43.0466C8.64321 43.0466 8.46655 43.2233 8.46655 43.4441C8.46655 43.665 8.64321 43.8416 8.86404 43.8416C9.08486 43.8416 9.26152 43.665 9.26152 43.4441C9.26152 43.2233 9.08486 43.0466 8.86404 43.0466Z",
    fill: "#C78031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6196 41.9138C41.3548 42.0462 41.1782 42.3184 41.1782 42.6347C41.1782 42.951 41.3621 43.2232 41.6196 43.3556C41.7299 43.4144 41.855 43.4438 41.9874 43.4438C42.1713 43.4438 42.3405 43.385 42.4729 43.282C42.6715 43.1349 42.7965 42.8995 42.7965 42.6347C42.7965 42.3699 42.6715 42.1345 42.4729 41.9874C42.3405 41.8844 42.1713 41.8255 41.9874 41.8255C41.855 41.8255 41.7299 41.855 41.6196 41.9138ZM42.3846 42.6347C42.3846 42.8554 42.208 43.0319 41.9874 43.0319C41.7667 43.0319 41.5902 42.8554 41.5902 42.6347C41.5902 42.414 41.7667 42.2375 41.9874 42.2375C42.208 42.2375 42.3846 42.414 42.3846 42.6347Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5901 42.635C41.5901 42.8558 41.7667 43.0324 41.9876 43.0324C42.2084 43.0324 42.3851 42.8558 42.3851 42.635C42.3851 42.4141 42.2084 42.2375 41.9876 42.2375C41.7667 42.2375 41.5901 42.4141 41.5901 42.635Z",
    fill: "#C78031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4345 43.694C38.4639 43.613 38.4787 43.5321 38.4787 43.4439C38.4787 43.0099 38.1329 42.6568 37.7063 42.6347C37.6916 42.6347 37.6842 42.6347 37.6695 42.6347C37.3606 42.6347 37.0957 42.8039 36.956 43.054C36.8898 43.1717 36.8604 43.3041 36.8604 43.4439C36.8604 43.8926 37.2208 44.253 37.6695 44.253C37.7063 44.253 37.7431 44.253 37.7798 44.2456C38.0888 44.2015 38.3389 43.9808 38.4345 43.694ZM37.6695 43.8411C37.4488 43.8411 37.2723 43.6645 37.2723 43.4439C37.2723 43.2232 37.4488 43.0466 37.6695 43.0466C37.8902 43.0466 38.0667 43.2232 38.0667 43.4439C38.0667 43.6645 37.8902 43.8411 37.6695 43.8411Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6699 43.0466C37.4491 43.0466 37.2725 43.2233 37.2725 43.4441C37.2725 43.665 37.4491 43.8416 37.6699 43.8416C37.8908 43.8416 38.0674 43.665 38.0674 43.4441C38.0674 43.2233 37.8908 43.0466 37.6699 43.0466Z",
    fill: "#C78031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0112 30.3724H29.3059L29.1882 30.137C29.0852 29.9311 29.1735 29.6736 29.3794 29.5706C29.4383 29.5412 29.5045 29.5265 29.5633 29.5265H29.556H28.0186C28.1142 29.6442 28.1731 29.7913 28.1731 29.9531C28.1583 30.1076 28.1069 30.2547 28.0112 30.3724Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9868 29.9458C22.9868 30.1812 22.7955 30.3724 22.5601 30.3724H22.207C22.3321 30.5195 22.516 30.6225 22.7293 30.6225C22.7514 30.6225 22.7734 30.6225 22.7955 30.6225C22.8617 30.6152 22.9279 30.6005 22.9868 30.571C23.0088 30.5637 23.0235 30.5563 23.0456 30.5416C23.0824 30.5195 23.1192 30.4975 23.1559 30.4681C23.2221 30.4166 23.281 30.343 23.3178 30.2694C23.3472 30.2106 23.3693 30.1518 23.384 30.0855C23.3913 30.0414 23.3987 29.9973 23.3987 29.9531C23.3987 29.909 23.3913 29.8649 23.384 29.8207C23.3546 29.6883 23.2883 29.5706 23.2001 29.4824C23.1854 29.4676 23.1707 29.4529 23.1559 29.4382C23.053 29.3573 22.9353 29.2985 22.7955 29.2911C22.7734 29.2911 22.7514 29.2911 22.7293 29.2911C22.516 29.2911 22.3321 29.3867 22.207 29.5412H22.5601C22.7955 29.5191 22.9868 29.7104 22.9868 29.9458Z",
    fill: "#29292F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1561 29.4309C23.1708 29.4456 23.1856 29.4603 23.2003 29.475C23.2885 29.5633 23.3547 29.681 23.3842 29.8134C23.3915 29.8575 23.3989 29.9017 23.3989 29.9458C23.3989 29.9899 23.3915 30.0341 23.3842 30.0782C23.3695 30.1444 23.3474 30.2032 23.318 30.2621C23.2738 30.3356 23.2223 30.4092 23.1561 30.4607C23.1194 30.4901 23.0899 30.5122 23.0458 30.5343C23.0237 30.5416 23.009 30.5563 22.9869 30.5637C22.9281 30.5858 22.8619 30.6078 22.7957 30.6152C22.7736 30.6152 22.7516 30.6152 22.7295 30.6152H27.4888C27.7021 30.6152 27.886 30.5195 28.011 30.3651C28.1067 30.2474 28.1655 30.1003 28.1655 29.9384C28.1655 29.7766 28.1067 29.6295 28.011 29.5118C27.886 29.3647 27.7021 29.2617 27.4888 29.2617H22.7295C22.7516 29.2617 22.7736 29.2617 22.7957 29.2617C22.9281 29.2911 23.0532 29.3426 23.1561 29.4309Z",
    fill: "#3C3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2866 33.9547C18.1836 34.1607 18.2718 34.4182 18.4778 34.5211C18.6838 34.6241 18.9412 34.5359 19.0442 34.3299L19.3532 33.712L20.2579 31.9172L21.0377 30.3651H20.8023C20.5669 30.3651 20.3756 30.1738 20.3756 29.9384C20.3756 29.7104 20.5595 29.5191 20.7876 29.5118C20.6257 29.5044 20.4713 29.5927 20.3903 29.7472L19.3017 31.9098L18.3969 33.7046L18.2866 33.9547Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1805 30.137L29.2982 30.3724L30.0779 31.9245L30.9827 33.7193L31.2917 34.3372C31.3947 34.5432 31.6521 34.6315 31.8581 34.5285C32.064 34.4255 32.1523 34.1681 32.0493 33.9621L31.9316 33.7267L31.0269 31.9319L29.9382 29.7692C29.8646 29.6221 29.7102 29.5338 29.5483 29.5338C29.4895 29.5338 29.4233 29.5486 29.3644 29.578C29.1658 29.6662 29.0775 29.9237 29.1805 30.137Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3831 29.9458C20.3831 30.1811 20.5743 30.3724 20.8097 30.3724H21.0451H22.2H22.553C22.7884 30.3724 22.9797 30.1811 22.9797 29.9458C22.9797 29.7104 22.7884 29.5191 22.553 29.5191H22.2H20.8097C20.8023 29.5191 20.8023 29.5191 20.795 29.5191C20.5743 29.5265 20.3831 29.7177 20.3831 29.9458Z",
    fill: "#F4B754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.774 35.7569H59.377V46.5995H131.774V35.7569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1931 43.1348L77.811 46.5994H113.906L114.546 43.1348H77.1931Z",
    fill: "url(#paint1_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3424 43.1349C44.7461 43.1349 44.908 46.5995 46.3424 46.5995C47.7768 46.5995 59.377 46.5995 59.377 46.5995L60.017 43.1349C60.017 43.1349 47.9386 43.1349 46.3424 43.1349Z",
    fill: "url(#paint2_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.791 45.8124V43.9293C137.791 43.4953 137.416 43.1422 136.945 43.1422H136.445H130.803L131.553 46.6069H136.445H136.945C137.408 46.5995 137.791 46.2464 137.791 45.8124Z",
    fill: "url(#paint3_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9087 32.7336V43.1422H60.0169C60.0169 43.1422 62.3782 37.9416 68.947 37.9416C75.5158 37.9416 77.1929 43.1422 77.1929 43.1422H114.539C114.539 42.9804 116.179 38.3388 122.932 38.3388C129.685 38.3388 130.788 43.1422 130.788 43.1422H136.349V32.7336H46.9087Z",
    fill: "url(#paint4_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.238 9.82733V8.46649H51.7123L50.7192 9.82733H116.238Z",
    fill: "#D9D9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.238 8.46649L115.436 7.09829H52.0285L51.7122 8.46649H116.238Z",
    fill: "url(#paint5_radial_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.915 26.6135H46.9087V24.7451H125.161L134.915 26.6135Z",
    fill: "#D9D9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.356 29.2175H46.9087V32.7336H136.356V29.2175Z",
    fill: "url(#paint6_radial_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9087 29.2175H136.364L134.915 26.6135H46.9087V29.2175Z",
    fill: "url(#paint7_radial_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.141 31.1889H128.853C128.5 31.1889 128.213 30.902 128.213 30.5489C128.213 30.1958 128.5 29.9089 128.853 29.9089H131.141C131.494 29.9089 131.781 30.1958 131.781 30.5489C131.781 30.902 131.487 31.1889 131.141 31.1889Z",
    fill: "#F68D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4544 31.1889H48.255C47.8799 31.1889 47.5415 30.902 47.5415 30.5489C47.5415 30.1958 47.8799 29.9089 48.255 29.9089H50.4544C50.8296 29.9089 51.1385 30.1958 51.1385 30.5489C51.1385 30.902 50.8296 31.1889 50.4544 31.1889Z",
    fill: "#F68D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.58 23.7741H123.69C123.499 23.7741 123.322 23.6785 123.212 23.524L116.29 11.7693C116.025 11.3941 116.297 10.8719 116.768 10.8719H116.871L116.246 9.82734H50.7193L46.9163 24.7378H125.168L124.58 23.7741ZM62.3416 13.2405L60.1642 21.7733C60.0539 22.1926 59.6567 22.4942 59.1933 22.4942H51.3004C50.6531 22.4942 50.1749 21.9278 50.3294 21.3393L52.5067 12.8065C52.6171 12.3872 53.0143 12.0856 53.4777 12.0856H61.3633C62.0106 12.0856 62.4887 12.652 62.3416 13.2405ZM118.46 23.7741H106.499C105.889 23.7741 105.396 23.2886 105.396 22.6928L105.881 12.0268C106.006 11.2617 106.374 10.9454 106.985 10.9454H113.061C113.428 10.9454 113.767 11.122 113.973 11.4162L119.372 22.0823C119.872 22.7958 119.35 23.7741 118.46 23.7741Z",
    fill: "url(#paint8_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 30.5121H59.274L59.068 31.2624H58.2957L59.3328 27.6875H60.2376L61.2601 31.2624H60.4877L60.2891 30.5121ZM59.4505 29.8575H60.1273L59.8036 28.5849L59.4505 29.8575Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5781 28.8203L64.8792 31.2551H64.2981L63.614 28.8203V31.2551H62.9299V27.6801H63.9524L64.585 29.9825L65.225 27.6801H66.2622V31.2551H65.5781V28.8203Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4397 31.2624H68.1377V27.6874H69.4691C69.6236 27.6874 69.7781 27.7022 69.9252 27.7316C70.0723 27.761 70.2047 27.8125 70.3224 27.8861C70.4401 27.9596 70.5284 28.0552 70.6019 28.1803C70.6681 28.3053 70.7049 28.4525 70.7049 28.6364C70.7049 28.7982 70.6681 28.9453 70.5872 29.0777C70.5137 29.2101 70.396 29.3131 70.2488 29.3867C70.4474 29.4749 70.5872 29.5853 70.6608 29.725C70.7343 29.8721 70.7785 30.0487 70.7785 30.2547C70.7785 30.6077 70.6608 30.8652 70.4254 31.027C70.2047 31.1815 69.8737 31.2624 69.4397 31.2624ZM69.4912 28.3348H68.9027V29.0556H69.5132C69.5647 29.0556 69.6236 29.0483 69.6751 29.0336C69.7266 29.0189 69.7707 28.9968 69.8075 28.9674C69.8443 28.9379 69.8737 28.9012 69.9031 28.8644C69.9252 28.8202 69.9399 28.7688 69.9399 28.7099C69.9399 28.5849 69.9031 28.4892 69.8296 28.4304C69.7486 28.3715 69.6383 28.3348 69.4912 28.3348ZM69.5132 29.7103H68.9027V30.6077H69.5206C69.6824 30.6077 69.8075 30.571 69.8958 30.5048C69.9767 30.4386 70.0208 30.3209 70.0208 30.1517C70.0208 29.9972 69.984 29.8869 69.9031 29.8207C69.8075 29.7471 69.6824 29.7103 69.5132 29.7103Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1036 31.3066C73.6623 31.3066 73.3239 31.1889 73.0811 30.9535C72.8384 30.7181 72.7207 30.3797 72.7207 29.9384V27.6801H73.4857V29.8869C73.4857 30.1664 73.5298 30.365 73.6255 30.4753C73.7137 30.593 73.8682 30.6519 74.0963 30.6519C74.2213 30.6519 74.3169 30.6372 74.3978 30.6078C74.4788 30.5783 74.5376 30.5342 74.5817 30.4827C74.6774 30.3724 74.7215 30.1738 74.7215 29.9016V27.6801H75.4865V29.9016C75.4865 30.3577 75.3688 30.7034 75.1334 30.9461C74.8907 31.1889 74.5523 31.3066 74.1036 31.3066Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3623 27.6801H78.1273V30.6078H79.6353V31.2624H77.3623V27.6801Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0408 30.5121H82.0257L81.8197 31.2624H81.0474L82.0845 27.6874H82.9893L84.0118 31.2624H83.2394L83.0408 30.5121ZM82.1949 29.8574H82.8716L82.548 28.5849L82.1949 29.8574Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4099 28.9159V31.2624H85.6816V27.6874H86.454L87.7486 29.931V27.6874H88.4769V31.2624H87.7634L86.4099 28.9159Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6989 31.3066C91.4267 31.3066 91.1987 31.2551 91.0148 31.1521C90.8309 31.0491 90.6838 30.9093 90.5661 30.7402C90.4557 30.571 90.3748 30.3724 90.3233 30.1517C90.2718 29.931 90.2498 29.703 90.2498 29.4676C90.2498 29.2322 90.2718 29.0042 90.3233 28.7835C90.3748 28.5628 90.4557 28.3642 90.5661 28.195C90.6764 28.0258 90.8309 27.8861 91.0148 27.7831C91.1987 27.6801 91.4267 27.6286 91.6989 27.6286C91.9931 27.6286 92.2506 27.6948 92.4712 27.8272C92.5816 27.8934 92.6772 27.9891 92.7655 28.1215C92.8464 28.2465 92.9199 28.4157 92.9788 28.629L92.28 28.7982C92.2285 28.6511 92.1549 28.526 92.0667 28.4304C91.9784 28.3348 91.846 28.2833 91.6842 28.2833C91.5885 28.2833 91.5003 28.3054 91.4341 28.3421C91.3605 28.3789 91.3016 28.4378 91.2502 28.504C91.1987 28.5702 91.1619 28.6437 91.1325 28.732C91.103 28.8129 91.081 28.9012 91.0663 28.9895C91.0515 29.0777 91.0368 29.166 91.0368 29.2543C91.0295 29.3425 91.0295 29.4235 91.0295 29.4897C91.0295 29.8722 91.0883 30.1664 91.1987 30.365C91.3017 30.5563 91.4708 30.6519 91.7062 30.6519C91.8019 30.6519 91.8754 30.6372 91.9416 30.6151C92.0078 30.593 92.0667 30.5563 92.1108 30.5048C92.1623 30.4606 92.1991 30.4018 92.2432 30.3356C92.28 30.2694 92.3168 30.2032 92.3535 30.1223L93.0744 30.3062C93.0009 30.4901 92.9273 30.6372 92.839 30.7622C92.7508 30.8799 92.6551 30.9829 92.5448 31.0638C92.3168 31.233 92.0372 31.3066 91.6989 31.3066Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7957 27.6801H97.1937V28.3348H95.5607V29.063H96.7523V29.7177L95.5607 29.725V30.6078H97.2525V31.2624H94.7957V27.6801Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05 2.9569H110.559L111.751 5.58296H104.858L106.05 2.9569Z",
    fill: "#4177A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.862 6.42934L111.754 6.42934V5.58341L104.862 5.58341V6.42934Z",
    fill: "#918B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.135 7.09869H109.481V6.42931H107.135V7.09869Z",
    fill: "#5A5761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.527 3.41299H53.3377C52.8963 3.41299 52.5285 3.75136 52.5285 4.16329L52.0283 7.09094H103.527V3.41299Z",
    fill: "#D9D9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.527 2.5082H54.7134V3.41298H103.527V2.5082Z",
    fill: "#C5C6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.885 38.6552C134.201 38.6552 133.642 38.133 133.642 37.4856V31.6083C133.642 30.9609 134.201 30.4387 134.885 30.4387H136.526V38.6626H134.885V38.6552Z",
    fill: "#5D4B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.401 30.5563V38.5374H134.878C134.26 38.5374 133.752 38.0666 133.752 37.4855V31.6082C133.752 31.027 134.26 30.5563 134.878 30.5563H136.401ZM136.643 30.3135H136.408H134.885C134.135 30.3135 133.517 30.8946 133.517 31.6008V37.4782C133.517 38.1917 134.128 38.7655 134.885 38.7655H136.408H136.643V38.5301V30.5489V30.3135Z",
    fill: "#0E0527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.401 36.2498H135.121C134.929 36.2498 134.768 36.3969 134.768 36.5808V37.5003C134.768 37.6842 134.922 37.8313 135.121 37.8313H136.401V36.2498Z",
    fill: "#F68D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.401 31.3287H135.121C134.93 31.3287 134.768 31.4758 134.768 31.6597V35.4333C134.768 35.6172 134.922 35.7643 135.121 35.7643H136.401V31.3287Z",
    fill: "#DBD1E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.881 12.0194L105.395 22.6854C105.395 23.2812 105.888 23.7667 106.499 23.7667H118.459C119.349 23.7667 119.872 22.7884 119.371 22.0749L113.972 11.4088C113.766 11.1146 113.428 10.938 113.06 10.938H106.984C106.374 10.938 105.998 11.2543 105.881 12.0194Z",
    fill: "#50A5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.282 11.7692L123.204 23.524C123.314 23.6784 123.491 23.7741 123.682 23.7741H124.572L116.856 10.8792H116.753C116.297 10.8792 116.017 11.3941 116.282 11.7692Z",
    fill: "#50A5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1639 21.7659L62.3413 13.2331C62.4884 12.6446 62.0176 12.0782 61.3703 12.0782H53.4774C53.014 12.0782 52.6094 12.3725 52.5064 12.7991L50.3291 21.3319C50.182 21.9204 50.6527 22.4868 51.3 22.4868H59.1856C59.649 22.4868 60.0536 22.1926 60.1639 21.7659Z",
    fill: "#50A5DC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.008 11.4823L105.696 16.0062L105.645 17.1169L114.435 12.3282L114.008 11.4823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.024 15.4618L115.024 13.4831L105.579 18.6249L105.461 21.2141L116.024 15.4618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.583 16.5652L105.402 22.6559V22.6927C105.402 23.2885 105.895 23.774 106.505 23.774H107.109L117.4 18.1688L116.583 16.5652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.211 23.5239C123.321 23.6784 123.498 23.774 123.689 23.774H124.373L124.528 23.6858L122.821 20.839L121.917 21.3319L123.211 23.5239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.938 19.6695L121.835 19.184L121.1 17.9629L120.217 18.441L120.938 19.6695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9214 14.8661L62.3333 13.2404C62.4289 12.8726 62.2744 12.5195 61.9949 12.2989L51.1155 18.2204L50.3652 21.1554L61.9214 14.8661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7064 12.0855L51.8805 15.2559L51.5569 16.5211L59.6999 12.0855H57.7064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5092 16.4991L50.7695 22.347C50.924 22.4353 51.1079 22.4941 51.2992 22.4941H54.2709L60.8986 18.8824L61.5092 16.4991Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.06 10.938C113.428 10.938 113.766 11.1146 113.972 11.4088L119.371 22.0749C119.872 22.7958 119.349 23.7667 118.459 23.7667H106.499C105.888 23.7667 105.395 23.2812 105.395 22.6854L105.881 12.0194C106.006 11.2543 106.373 10.938 106.984 10.938H113.06ZM113.06 10.5703H106.984C106.418 10.5703 105.697 10.813 105.52 11.9605C105.52 11.9752 105.52 11.9899 105.513 12.0047L105.027 22.6707C105.027 23.4872 105.689 24.1345 106.499 24.1345H118.459C119.011 24.1345 119.518 23.8329 119.769 23.3475C120.019 22.8767 119.989 22.3323 119.688 21.8836L114.296 11.2323C114.288 11.2176 114.281 11.2029 114.266 11.1881C114.002 10.8056 113.545 10.5703 113.06 10.5703Z",
    fill: "#0E0527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.863 10.8792L124.579 23.7741H123.689C123.498 23.7741 123.322 23.6785 123.211 23.524L116.289 11.7693C116.025 11.3941 116.297 10.8718 116.767 10.8718H116.863M117.076 10.504H116.87H116.767C116.407 10.504 116.083 10.7027 115.922 11.0116C115.76 11.3132 115.782 11.681 115.973 11.9605L122.895 23.7079L122.902 23.7226L122.91 23.7373C123.086 23.9874 123.38 24.1419 123.689 24.1419H124.579H125.227L124.896 23.5828L117.179 10.6879L117.076 10.504Z",
    fill: "#0E0527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3626 12.0856C62.01 12.0856 62.4881 12.652 62.3336 13.2405L60.1563 21.7733C60.0459 22.1926 59.6487 22.4942 59.1853 22.4942H51.2998C50.6524 22.4942 50.1743 21.9278 50.3288 21.3393L52.5061 12.8065C52.6165 12.3872 53.0137 12.0856 53.4771 12.0856H61.3626ZM61.3626 11.7178H53.4771C52.8445 11.7178 52.2928 12.1297 52.1457 12.7108L49.9683 21.2437C49.8727 21.6188 49.9536 22.0161 50.1964 22.325C50.4538 22.6634 50.8584 22.8546 51.2998 22.8546H59.1853C59.8179 22.8546 60.3696 22.4427 60.5167 21.8616L62.6941 13.3287C62.7897 12.9536 62.7088 12.5564 62.466 12.2474C62.2012 11.909 61.804 11.7178 61.3626 11.7178Z",
    fill: "#0E0527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.252 9.82732L122.248 24.7451",
    stroke: "#ADAEB6",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.173 43.1349V26.9225L103.519 9.89353",
    stroke: "#ADAEB6",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.248 24.7451V38.3535",
    stroke: "#ADAEB6",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8037 43.1349V9.82732",
    stroke: "#ADAEB6",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8167 17.86L72.6026 16.4918L74.8167 15.1236C74.9124 15.0647 74.9491 14.9323 74.8829 14.8367L74.0664 13.52C74.0076 13.4244 73.8752 13.3876 73.7795 13.4538L71.7052 14.7337V12.2989C71.7052 12.1812 71.6096 12.0856 71.4919 12.0856H69.9398C69.8221 12.0856 69.7264 12.1812 69.7264 12.2989V14.7337L67.6521 13.4538C67.5565 13.3949 67.424 13.4244 67.3652 13.52L66.5487 14.8367C66.4899 14.9323 66.5193 15.0647 66.6149 15.1236L68.829 16.4918L66.6149 17.86C66.5193 17.9188 66.4825 18.0512 66.5487 18.1469L67.3652 19.4636C67.424 19.5592 67.5565 19.596 67.6521 19.5298L69.7264 18.2498V20.6846C69.7264 20.8023 69.8221 20.898 69.9398 20.898H71.4919C71.6096 20.898 71.7052 20.8023 71.7052 20.6846V18.2572L73.7795 19.5371C73.8752 19.596 74.0076 19.5666 74.0664 19.4709L74.8829 18.1542C74.9418 18.0512 74.9124 17.9188 74.8167 17.86Z",
    fill: "url(#paint9_radial_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9934 17.5731L73.2427 16.4918L74.9934 15.4104C75.1184 15.3369 75.2067 15.2118 75.2361 15.0721C75.2729 14.9323 75.2435 14.7852 75.1699 14.6601L74.3534 13.3434C74.2799 13.2184 74.1548 13.1301 74.0151 13.1007C73.8753 13.0639 73.7282 13.0933 73.6031 13.1669L72.051 14.1305V12.3062C72.051 12.0047 71.8083 11.7546 71.4993 11.7546H69.9472C69.6457 11.7546 69.3956 11.9973 69.3956 12.3062V14.1305L67.8435 13.1669C67.586 13.0051 67.2476 13.086 67.0858 13.3434L66.2693 14.6601C66.1957 14.7852 66.1663 14.9323 66.2031 15.0721C66.2399 15.2118 66.3208 15.3369 66.4458 15.4104L68.1965 16.4918L66.4458 17.5731C66.3208 17.6466 66.2325 17.7717 66.2031 17.9115C66.1663 18.0512 66.1957 18.1983 66.2693 18.3234L67.0858 19.6401C67.2476 19.8975 67.586 19.9785 67.8435 19.8166L69.3956 18.853V20.6773C69.3956 20.9789 69.6383 21.229 69.9472 21.229H71.4993C71.8009 21.229 72.051 20.9862 72.051 20.6773V18.853L73.6031 19.8166C73.7282 19.8902 73.8753 19.9196 74.0151 19.8828C74.1548 19.8461 74.2799 19.7651 74.3534 19.6401L75.1699 18.3234C75.2435 18.1983 75.2729 18.0512 75.2361 17.9115C75.2067 17.7717 75.1184 17.6466 74.9934 17.5731ZM75.0743 18.2719L74.2578 19.5886C74.199 19.6916 74.096 19.7578 73.9856 19.7872C73.8753 19.8166 73.7576 19.7946 73.6546 19.7357L72.0143 18.7206C71.9995 18.7132 71.9775 18.7132 71.9554 18.7206C71.9407 18.728 71.926 18.75 71.926 18.7721V20.6993C71.926 20.9421 71.7274 21.1407 71.4846 21.1407H69.9325C69.6898 21.1407 69.4912 20.9421 69.4912 20.6993V18.7721C69.4912 18.75 69.4838 18.7353 69.4618 18.7206C69.4544 18.7132 69.447 18.7132 69.4323 18.7132C69.425 18.7132 69.4103 18.7132 69.4029 18.7206L67.7625 19.7357C67.5566 19.8608 67.2844 19.8019 67.1594 19.5959L66.3429 18.2792C66.284 18.1763 66.2619 18.0586 66.2914 17.9482C66.3208 17.8305 66.387 17.7349 66.49 17.6761L68.3142 16.5506C68.329 16.5433 68.3437 16.5212 68.3437 16.5065C68.3437 16.4844 68.3363 16.4697 68.3142 16.4623L66.49 15.3369C66.387 15.278 66.3208 15.1751 66.2914 15.0647C66.2619 14.947 66.284 14.8293 66.3429 14.7337L67.1594 13.417C67.2844 13.211 67.5566 13.1448 67.7625 13.2772L69.4029 14.2923C69.4176 14.2997 69.4397 14.2997 69.4618 14.2923C69.4765 14.285 69.4912 14.2629 69.4912 14.2409V12.3136C69.4912 12.0709 69.6898 11.8722 69.9325 11.8722H71.4846C71.7274 11.8722 71.926 12.0709 71.926 12.3136V14.2409C71.926 14.2629 71.9333 14.2776 71.9554 14.2923C71.9701 14.2997 71.9922 14.2997 72.0143 14.2923L73.6546 13.2772C73.7576 13.2184 73.8753 13.1963 73.9856 13.2257C74.096 13.2552 74.199 13.3214 74.2578 13.4244L75.0743 14.7411C75.1332 14.844 75.1552 14.9617 75.1258 15.0721C75.0964 15.1898 75.0302 15.2854 74.9272 15.3442L73.1029 16.4697C73.0882 16.477 73.0735 16.4991 73.0735 16.5138C73.0735 16.5359 73.0809 16.5506 73.1029 16.558L74.9272 17.6834C75.0302 17.7423 75.0964 17.8452 75.1258 17.9556C75.1552 18.0512 75.1405 18.1689 75.0743 18.2719Z",
    fill: "#D73747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1958 21.9131H66.799V22.0749H66.3871V22.2588H66.6887V22.4206H66.3871V22.6413H66.8137V22.8031H66.1958V21.9131Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.873 22.2L67.6965 22.8179H67.5493L67.3728 22.2V22.8179H67.2036V21.9131H67.4611L67.6229 22.4942L67.7847 21.9131H68.0495V22.8179H67.8804V22.2H67.873Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4468 21.9131H69.05V22.0749H68.638V22.2588H68.9396V22.4206H68.638V22.6413H69.0647V22.8032H68.4468V21.9131Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7638 22.4648H69.6388V22.8252H69.4475V21.9205H69.8079C69.8521 21.9205 69.8962 21.9278 69.9256 21.9352C69.9624 21.9499 69.9918 21.9646 70.0213 21.9867C70.0433 22.0087 70.0654 22.0381 70.0801 22.0749C70.0948 22.1117 70.1022 22.1485 70.1022 22.2C70.1022 22.2515 70.0875 22.303 70.058 22.3397C70.0286 22.3765 69.9918 22.4059 69.9404 22.428L70.139 22.8252H69.9256L69.7638 22.4648ZM69.7712 22.0823H69.6388V22.2956H69.7565C69.7785 22.2956 69.7932 22.2956 69.8153 22.2956C69.8374 22.2956 69.8521 22.2882 69.8668 22.2809C69.8815 22.2735 69.8962 22.2662 69.9036 22.2515C69.9109 22.2368 69.9183 22.222 69.9183 22.2C69.9183 22.1779 69.9183 22.1632 69.9109 22.1485C69.9036 22.1338 69.8962 22.1191 69.8889 22.1117C69.8594 22.0896 69.8227 22.0823 69.7712 22.0823Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0435 22.7517C71.0141 22.7811 70.9773 22.8032 70.9479 22.8179C70.9111 22.8326 70.8743 22.8326 70.8302 22.8326C70.764 22.8326 70.7052 22.8179 70.661 22.7958C70.6169 22.7737 70.5801 22.737 70.5507 22.7002C70.5213 22.656 70.4992 22.6119 70.4845 22.5604C70.4698 22.5089 70.4624 22.4501 70.4624 22.3912C70.4624 22.325 70.4698 22.2662 70.4845 22.2073C70.4992 22.1485 70.5213 22.097 70.5507 22.0528C70.5801 22.0087 70.6242 21.9719 70.6684 21.9499C70.7199 21.9204 70.7787 21.9131 70.8523 21.9131C70.9185 21.9131 70.9847 21.9278 71.0435 21.9646C71.0729 21.9793 71.1024 22.0087 71.1244 22.0381C71.1465 22.0676 71.1686 22.1117 71.1833 22.1558L71.0067 22.2C70.9847 22.1558 70.97 22.1264 70.9405 22.1043C70.9185 22.0823 70.8817 22.0749 70.8376 22.0749C70.8008 22.0749 70.7714 22.0823 70.7493 22.1043C70.7272 22.1264 70.7125 22.1558 70.6978 22.1853C70.6831 22.2147 70.6757 22.2515 70.6757 22.2882C70.6757 22.325 70.6684 22.3544 70.6684 22.3839C70.6684 22.4133 70.6684 22.4427 70.6757 22.4795C70.6831 22.5163 70.6904 22.5457 70.6978 22.5751C70.7052 22.6045 70.7272 22.6266 70.7493 22.6487C70.7714 22.6707 70.8008 22.6781 70.8376 22.6781C70.889 22.6781 70.9258 22.6634 70.9626 22.6266C70.992 22.5972 71.0067 22.5678 71.0067 22.5236H70.8376V22.3618H71.1906V22.8326H71.0435V22.7517Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6099 21.9131H72.2131V22.0749H71.8011V22.2588H72.1027V22.4206H71.8011V22.6413H72.2278V22.8032H71.6099V21.9131Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8016 22.2294V22.8252H72.6177V21.9205H72.8163L73.1399 22.4869V21.9205H73.3238V22.8252H73.1399L72.8016 22.2294Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0667 22.8326C74.0005 22.8326 73.9417 22.8179 73.8976 22.7958C73.8534 22.7664 73.8166 22.737 73.7872 22.6928C73.7578 22.6487 73.7357 22.5972 73.7284 22.5457C73.7137 22.4869 73.7063 22.4354 73.7063 22.3692C73.7063 22.3103 73.7137 22.2515 73.7284 22.2C73.7431 22.1411 73.7578 22.097 73.7872 22.0528C73.8166 22.0087 73.8534 21.9719 73.8976 21.9499C73.9417 21.9204 74.0005 21.9131 74.0667 21.9131C74.1403 21.9131 74.2065 21.9278 74.258 21.9646C74.2874 21.9793 74.3095 22.0087 74.3316 22.0381C74.3536 22.0676 74.3683 22.1117 74.383 22.1632L74.2065 22.2073C74.1918 22.1705 74.1771 22.1411 74.155 22.1117C74.1329 22.0896 74.1035 22.0749 74.0594 22.0749C74.0373 22.0749 74.0152 22.0823 73.9932 22.0896C73.9785 22.097 73.9564 22.1117 73.949 22.1264C73.9343 22.1411 73.927 22.1632 73.9196 22.1853C73.9123 22.2073 73.9049 22.2294 73.9049 22.2515C73.8976 22.2735 73.8976 22.2956 73.8976 22.3177C73.8976 22.3397 73.8976 22.3618 73.8976 22.3765C73.8976 22.4721 73.9123 22.5457 73.9417 22.5972C73.9711 22.6487 74.0079 22.6707 74.0741 22.6707C74.0962 22.6707 74.1182 22.6707 74.1329 22.6634C74.1477 22.656 74.1624 22.6487 74.1771 22.634C74.1918 22.6193 74.1991 22.6119 74.2065 22.5898C74.2139 22.5751 74.2286 22.553 74.2359 22.5383L74.4198 22.5825C74.4051 22.6266 74.383 22.6634 74.361 22.7002C74.3389 22.7296 74.3168 22.759 74.2874 22.7737C74.2212 22.8105 74.1477 22.8326 74.0667 22.8326Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1186 22.8179H74.9273V22.4574L74.6772 21.9131H74.8832L75.023 22.2367L75.1627 21.9131H75.3687L75.1186 22.4574V22.8179Z",
    fill: "#EF3F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 9.82734L33.3147 24.7378H46.6362L50.4392 9.82734H37.1177ZM45.3342 21.766C45.2313 22.1853 44.8561 22.4868 44.4221 22.4868H37.0589C36.4557 22.4868 36.007 21.9204 36.1467 21.332L38.1843 12.7991C38.2873 12.3798 38.6624 12.0782 39.0964 12.0782H46.4671C47.0702 12.0782 47.5189 12.6446 47.3792 13.2331L45.3342 21.766Z",
    fill: "url(#paint10_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9697 32.6482H32.6482V43.0495H45.9697V32.6482Z",
    fill: "url(#paint11_linear_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6438 26.6135V24.7451H33.3223V26.6135H46.6438Z",
    fill: "#BEBFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6438 29.2175H33.3223V32.7337H46.6438V29.2175Z",
    fill: "url(#paint12_radial_343_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6438 26.6135H33.3223V29.2175H46.6438V26.6135Z",
    fill: "url(#paint13_radial_343_4124)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3346 21.766L47.3722 13.2331C47.5119 12.6446 47.0632 12.0782 46.46 12.0782H39.0894C38.6554 12.0782 38.2803 12.3725 38.1773 12.7991L36.1397 21.332C35.9999 21.9204 36.4486 22.4868 37.0518 22.4868H44.4224C44.8564 22.4868 45.2389 22.1926 45.3346 21.766Z",
    fill: "#50A5DC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9823 14.8661L47.3721 13.2405C47.4604 12.8727 47.3206 12.5196 47.0558 12.2989L36.89 18.2204L36.1912 21.1554L46.9823 14.8661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0396 12.0856L37.5963 15.256L37.2947 16.5212L44.9007 12.0856H43.0396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5923 16.4991L36.5588 22.3471C36.6986 22.4353 36.8751 22.4942 37.059 22.4942H39.8322L46.0259 18.8824L46.5923 16.4991Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.4601 12.0856C47.0633 12.0856 47.512 12.652 47.3722 13.2405L45.3346 21.7733C45.2317 22.1926 44.8565 22.4942 44.4225 22.4942H37.0593C36.4561 22.4942 36.0074 21.9278 36.1471 21.3393L38.1847 12.8065C38.2877 12.3872 38.6628 12.0856 39.0968 12.0856H46.4601ZM46.4601 11.7325H39.0895C38.4863 11.7325 37.9714 12.1371 37.8316 12.7256L35.794 21.2511C35.6984 21.6409 35.7867 22.0382 36.0368 22.3545C36.2869 22.6634 36.6547 22.8473 37.0519 22.8473H44.4225C45.0257 22.8473 45.5406 22.4427 45.6804 21.8543L47.718 13.3288C47.8136 12.9389 47.7253 12.5417 47.4752 12.2254C47.2251 11.9091 46.8573 11.7325 46.4601 11.7325Z",
    fill: "#0E0527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4252 30.6519V28.3348H33.3223V31.1668H34.6243V30.6519H33.4252Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.478 30.571H35.6762L35.5143 31.1668H34.9038L35.7203 28.3348H36.4338L37.243 31.1668H36.6324L36.478 30.571ZM35.8086 30.0561H36.3456L36.0881 29.0483L35.8086 30.0561Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3023 29.3132V31.1668H37.7212V28.3348H38.3317L39.3542 30.1076V28.3348H39.9353V31.1668H39.3763L38.3023 29.3132Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6419 31.2036C41.4286 31.2036 41.2447 31.1595 41.0976 31.0786C40.9505 30.9977 40.8328 30.8873 40.7445 30.7549C40.6562 30.6225 40.59 30.468 40.5532 30.2915C40.5165 30.1149 40.4944 29.9384 40.4944 29.7471C40.4944 29.5632 40.5165 29.3794 40.5532 29.2102C40.59 29.0336 40.6562 28.8791 40.7445 28.7467C40.8328 28.6143 40.9505 28.504 41.0976 28.4231C41.2447 28.3422 41.4212 28.298 41.6419 28.298C41.8699 28.298 42.0759 28.3495 42.2524 28.4525C42.3407 28.504 42.4216 28.5849 42.4805 28.6805C42.5467 28.7835 42.5982 28.9159 42.6497 29.0778L42.0906 29.2102C42.0465 29.0925 41.995 28.9968 41.9214 28.9233C41.8479 28.8497 41.7449 28.8056 41.6198 28.8056C41.5463 28.8056 41.4801 28.8203 41.4212 28.8571C41.3624 28.8865 41.3182 28.9306 41.2815 28.9821C41.2447 29.0336 41.2153 29.0925 41.1858 29.1587C41.1638 29.2249 41.1417 29.2911 41.127 29.3646C41.1123 29.4382 41.1049 29.5044 41.1049 29.5706C41.0976 29.6368 41.0976 29.703 41.0976 29.7619C41.0976 30.0635 41.1417 30.2988 41.23 30.4533C41.3109 30.6078 41.4433 30.6813 41.6345 30.6813C41.7081 30.6813 41.7743 30.674 41.8258 30.6519C41.8773 30.6299 41.9214 30.6004 41.9582 30.5637C41.995 30.5269 42.0318 30.4827 42.0612 30.4312C42.0906 30.3798 42.12 30.3283 42.1495 30.2621L42.7232 30.4092C42.6644 30.5563 42.6055 30.674 42.5393 30.7696C42.4731 30.8652 42.3922 30.9462 42.3039 31.005C42.1347 31.1448 41.9141 31.2036 41.6419 31.2036Z",
    fill: "#E9E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2527 28.3348H45.1579V28.8497H43.8632V29.4309H44.8121V29.9458L43.8632 29.9531V30.6519H45.202V31.1668H43.2527V28.3348Z",
    fill: "#E9E5EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.8726 46.4363C75.8726 42.3292 72.5434 39 68.4363 39C64.3292 39 61 42.3292 61 46.4363C61 50.5433 64.3292 53.8726 68.4363 53.8726C72.5434 53.8726 75.8726 50.5433 75.8726 46.4363Z",
    fill: "url(#paint14_linear_343_4124)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2815 46.4363C75.2815 42.6715 72.2323 39.5912 68.4364 39.5912C64.6716 39.5912 61.5913 42.6404 61.5913 46.4363C61.5913 50.2322 64.6405 53.2814 68.4364 53.2814C72.2323 53.2814 75.2815 50.2011 75.2815 46.4363Z",
    fill: "#3B4447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.5706 46.4363C73.5706 43.6049 71.2682 41.3024 68.4368 41.3024C65.6054 41.3024 63.303 43.6049 63.303 46.4363C63.303 49.2677 65.6054 51.5701 68.4368 51.5701C71.2682 51.5701 73.5706 49.2677 73.5706 46.4363Z",
    fill: "url(#paint15_linear_343_4124)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4362 50.9789C70.9451 50.9789 72.9789 48.9451 72.9789 46.4363C72.9789 43.9274 70.9451 41.8936 68.4362 41.8936C65.9274 41.8936 63.8936 43.9274 63.8936 46.4363C63.8936 48.9451 65.9274 50.9789 68.4362 50.9789Z",
    fill: "url(#paint16_linear_343_4124)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6996 46.4363C72.6996 44.0716 70.8016 42.1425 68.437 42.1425C66.0723 42.1425 64.1743 44.0716 64.1743 46.4363C64.1743 48.801 66.0723 50.73 68.437 50.73C70.8016 50.73 72.6996 48.801 72.6996 46.4363Z",
    fill: "url(#paint17_linear_343_4124)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6146 46.4363C70.6146 45.2228 69.65 44.2583 68.4677 44.2583C67.2853 44.2583 66.3208 45.2228 66.3208 46.4363C66.3208 47.6497 67.2853 48.6143 68.4677 48.6143C69.65 48.6143 70.6146 47.6497 70.6146 46.4363Z",
    fill: "url(#paint18_linear_343_4124)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1791 46.4363C70.1791 45.4717 69.4013 44.6939 68.4367 44.6939C67.4722 44.6939 66.6943 45.4717 66.6943 46.4363C66.6943 47.4008 67.4722 48.1787 68.4367 48.1787C69.4013 48.1787 70.1791 47.4008 70.1791 46.4363Z",
    fill: "url(#paint19_linear_343_4124)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.054 46.4363C70.054 45.5651 69.3384 44.8183 68.4672 44.8183C67.596 44.8183 66.8804 45.534 66.8804 46.4363C66.8804 47.3386 67.596 48.0542 68.4672 48.0542C69.3384 48.0542 70.054 47.3075 70.054 46.4363Z",
    fill: "url(#paint20_linear_343_4124)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7517 46.4363C67.7517 46.8408 68.0628 47.1519 68.4673 47.1519C68.8718 47.1519 69.183 46.8408 69.183 46.4363C69.183 46.0318 68.8718 45.7206 68.4673 45.7206C68.0628 45.7206 67.7517 46.0318 67.7517 46.4363Z",
    fill: "url(#paint21_linear_343_4124)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9966 46.4363C68.9966 46.1251 68.7477 45.8762 68.4365 45.8762C68.1254 45.8762 67.8765 46.1251 67.8765 46.4363C67.8765 46.7474 68.1254 46.9963 68.4365 46.9963C68.7477 46.9963 68.9966 46.7474 68.9966 46.4363Z",
    fill: "url(#paint22_linear_343_4124)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4363 43.9783C68.5296 43.9783 68.623 43.9783 68.7163 43.9783L68.7785 42.547C68.6852 42.547 68.5607 42.5159 68.4674 42.5159C68.3429 42.5159 68.2496 42.5159 68.1562 42.547L68.2185 43.9783C68.2807 43.9783 68.3429 43.9783 68.4363 43.9783Z",
    fill: "#393B3D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8455 44.0405L67.4099 42.6715C67.1921 42.7337 67.0054 42.7959 66.7876 42.8893L67.3477 44.1961C67.5344 44.1649 67.6899 44.1027 67.8455 44.0405Z",
    fill: "#393B3D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0673 44.3827L66.1961 43.2626C66.0094 43.3871 65.8538 43.5427 65.6982 43.6671L66.6628 44.725C66.7872 44.6005 66.9428 44.5072 67.0673 44.3827Z",
    fill: "#393B3D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4762 45.005L65.2628 44.2272C65.1383 44.4139 65.045 44.6005 64.9517 44.7872L66.2273 45.4406C66.2896 45.2851 66.3518 45.1295 66.4762 45.005Z",
    fill: "#393B3D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2099 44.725L71.1744 43.6671C71.0189 43.5115 70.8633 43.3871 70.6766 43.2626L69.8054 44.3827C69.961 44.5072 70.0854 44.6005 70.2099 44.725Z",
    fill: "#393B3D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8945 46.2807L72.2946 46.094C72.2635 45.8762 72.2324 45.6584 72.1702 45.4406L70.77 45.7518C70.8322 45.9073 70.8634 46.094 70.8945 46.2807Z",
    fill: "#393B3D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1027 45.7518L64.7026 45.4406C64.6404 45.6584 64.6092 45.8762 64.5781 46.094L65.9783 46.2807C66.0094 46.094 66.0405 45.9073 66.1027 45.7518Z",
    fill: "#393B3D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5254 44.2272L70.0855 42.9204C69.8988 42.827 69.681 42.7648 69.4632 42.7026L69.0276 44.0716C69.2143 44.1027 69.3699 44.1649 69.5254 44.2272Z",
    fill: "#393B3D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6766 45.4406L71.9523 44.7872C71.859 44.6005 71.7657 44.4139 71.6412 44.2272L70.4277 45.005C70.5211 45.1295 70.6144 45.2851 70.6766 45.4406Z",
    fill: "#393B3D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4277 47.8675L71.6412 48.6454C71.7657 48.4587 71.859 48.272 71.9523 48.0853L70.6766 47.4319C70.6144 47.5875 70.5211 47.7431 70.4277 47.8675Z",
    fill: "#393B3D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0098 46.5918L64.6096 46.7785C64.6407 46.9963 64.6719 47.2141 64.7341 47.4319L66.1342 47.1208C66.0409 46.9652 66.0098 46.7785 66.0098 46.5918Z",
    fill: "#393B3D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8054 48.4898L70.6766 49.6099C70.8633 49.4855 71.0189 49.3299 71.1744 49.2054L70.2099 48.1476C70.0854 48.272 69.961 48.3654 69.8054 48.4898Z",
    fill: "#393B3D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8013 47.1208L72.2014 47.4319C72.2636 47.2141 72.2948 46.9963 72.3259 46.7785L70.9257 46.5918C70.8635 46.7785 70.8324 46.9652 70.8013 47.1208Z",
    fill: "#393B3D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0276 48.8321L69.4632 50.2011C69.681 50.1389 69.8677 50.0766 70.0855 49.9833L69.5254 48.6765C69.3699 48.7076 69.2143 48.7698 69.0276 48.8321Z",
    fill: "#393B3D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1961 47.4319L64.9204 48.0853C65.0138 48.272 65.1071 48.4587 65.2316 48.6454L66.445 47.8675C66.3517 47.7431 66.2894 47.5875 66.1961 47.4319Z",
    fill: "#393B3D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6628 48.1476L65.6982 49.2054C65.8538 49.361 66.0094 49.4855 66.1961 49.6099L67.0673 48.4898C66.9428 48.3654 66.7872 48.272 66.6628 48.1476Z",
    fill: "#393B3D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4365 48.8943C68.3432 48.8943 68.2498 48.8943 68.1565 48.8943L68.0942 50.3256C68.1876 50.3256 68.312 50.3567 68.4054 50.3567C68.5298 50.3567 68.6232 50.3567 68.7165 50.3256L68.6543 48.8943C68.6232 48.8943 68.5298 48.8943 68.4365 48.8943Z",
    fill: "#393B3D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3477 48.6454L66.7876 49.9833C66.9743 50.0766 67.1921 50.1389 67.4099 50.2011L67.8455 48.8321C67.6899 48.7698 67.5344 48.7076 67.3477 48.6454Z",
    fill: "#393B3D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.873 46.4363C129.873 42.3292 126.543 39 122.436 39C118.329 39 115 42.3292 115 46.4363C115 50.5433 118.329 53.8726 122.436 53.8726C126.543 53.8726 129.873 50.5433 129.873 46.4363Z",
    fill: "url(#paint23_linear_343_4124)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.282 46.4363C129.282 42.6715 126.232 39.5912 122.436 39.5912C118.672 39.5912 115.591 42.6404 115.591 46.4363C115.591 50.2322 118.64 53.2814 122.436 53.2814C126.232 53.2814 129.282 50.2011 129.282 46.4363Z",
    fill: "#3B4447"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.571 46.4363C127.571 43.6049 125.268 41.3024 122.437 41.3024C119.605 41.3024 117.303 43.6049 117.303 46.4363C117.303 49.2677 119.605 51.5701 122.437 51.5701C125.268 51.5701 127.571 49.2677 127.571 46.4363Z",
    fill: "url(#paint24_linear_343_4124)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.436 50.9789C124.945 50.9789 126.979 48.9451 126.979 46.4363C126.979 43.9274 124.945 41.8936 122.436 41.8936C119.927 41.8936 117.894 43.9274 117.894 46.4363C117.894 48.9451 119.927 50.9789 122.436 50.9789Z",
    fill: "url(#paint25_linear_343_4124)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.7 46.4363C126.7 44.0716 124.802 42.1425 122.437 42.1425C120.072 42.1425 118.174 44.0716 118.174 46.4363C118.174 48.801 120.072 50.73 122.437 50.73C124.802 50.73 126.7 48.801 126.7 46.4363Z",
    fill: "url(#paint26_linear_343_4124)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M124.615 46.4363C124.615 45.2228 123.65 44.2583 122.468 44.2583C121.285 44.2583 120.321 45.2228 120.321 46.4363C120.321 47.6497 121.285 48.6143 122.468 48.6143C123.65 48.6143 124.615 47.6497 124.615 46.4363Z",
    fill: "url(#paint27_linear_343_4124)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M124.179 46.4363C124.179 45.4717 123.401 44.6939 122.437 44.6939C121.472 44.6939 120.694 45.4717 120.694 46.4363C120.694 47.4008 121.472 48.1787 122.437 48.1787C123.401 48.1787 124.179 47.4008 124.179 46.4363Z",
    fill: "url(#paint28_linear_343_4124)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M124.054 46.4363C124.054 45.5651 123.338 44.8183 122.467 44.8183C121.596 44.8183 120.88 45.534 120.88 46.4363C120.88 47.3386 121.596 48.0542 122.467 48.0542C123.338 48.0542 124.054 47.3075 124.054 46.4363Z",
    fill: "url(#paint29_linear_343_4124)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.752 46.4363C121.752 46.8408 122.063 47.1519 122.467 47.1519C122.872 47.1519 123.183 46.8408 123.183 46.4363C123.183 46.0318 122.872 45.7206 122.467 45.7206C122.063 45.7206 121.752 46.0318 121.752 46.4363Z",
    fill: "url(#paint30_linear_343_4124)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M122.997 46.4363C122.997 46.1251 122.748 45.8762 122.437 45.8762C122.125 45.8762 121.876 46.1251 121.876 46.4363C121.876 46.7474 122.125 46.9963 122.437 46.9963C122.748 46.9963 122.997 46.7474 122.997 46.4363Z",
    fill: "url(#paint31_linear_343_4124)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M122.436 43.9783C122.53 43.9783 122.623 43.9783 122.716 43.9783L122.779 42.547C122.685 42.547 122.561 42.5159 122.467 42.5159C122.343 42.5159 122.25 42.5159 122.156 42.547L122.218 43.9783C122.281 43.9783 122.343 43.9783 122.436 43.9783Z",
    fill: "#393B3D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M121.845 44.0405L121.41 42.6715C121.192 42.7337 121.005 42.7959 120.788 42.8893L121.348 44.1961C121.534 44.1649 121.69 44.1027 121.845 44.0405Z",
    fill: "#393B3D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121.067 44.3827L120.196 43.2626C120.009 43.3871 119.854 43.5427 119.698 43.6671L120.663 44.725C120.787 44.6005 120.943 44.5072 121.067 44.3827Z",
    fill: "#393B3D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.476 45.005L119.263 44.2272C119.138 44.4139 119.045 44.6005 118.952 44.7872L120.227 45.4406C120.29 45.2851 120.352 45.1295 120.476 45.005Z",
    fill: "#393B3D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M124.21 44.725L125.174 43.6671C125.019 43.5115 124.863 43.3871 124.677 43.2626L123.805 44.3827C123.961 44.5072 124.085 44.6005 124.21 44.725Z",
    fill: "#393B3D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.894 46.2807L126.295 46.094C126.263 45.8762 126.232 45.6584 126.17 45.4406L124.77 45.7518C124.832 45.9073 124.863 46.094 124.894 46.2807Z",
    fill: "#393B3D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.103 45.7518L118.703 45.4406C118.64 45.6584 118.609 45.8762 118.578 46.094L119.978 46.2807C120.009 46.094 120.04 45.9073 120.103 45.7518Z",
    fill: "#393B3D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M123.525 44.2272L124.085 42.9204C123.899 42.827 123.681 42.7648 123.463 42.7026L123.028 44.0716C123.214 44.1027 123.37 44.1649 123.525 44.2272Z",
    fill: "#393B3D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.677 45.4406L125.952 44.7872C125.859 44.6005 125.766 44.4139 125.641 44.2272L124.428 45.005C124.521 45.1295 124.614 45.2851 124.677 45.4406Z",
    fill: "#393B3D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.428 47.8675L125.641 48.6454C125.766 48.4587 125.859 48.272 125.952 48.0853L124.677 47.4319C124.614 47.5875 124.521 47.7431 124.428 47.8675Z",
    fill: "#393B3D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M120.01 46.5918L118.61 46.7785C118.641 46.9963 118.672 47.2141 118.734 47.4319L120.134 47.1208C120.041 46.9652 120.01 46.7785 120.01 46.5918Z",
    fill: "#393B3D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M123.805 48.4898L124.677 49.6099C124.863 49.4855 125.019 49.3299 125.174 49.2054L124.21 48.1476C124.085 48.272 123.961 48.3654 123.805 48.4898Z",
    fill: "#393B3D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.801 47.1208L126.201 47.4319C126.264 47.2141 126.295 46.9963 126.326 46.7785L124.926 46.5918C124.864 46.7785 124.832 46.9652 124.801 47.1208Z",
    fill: "#393B3D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M123.028 48.8321L123.463 50.2011C123.681 50.1389 123.868 50.0766 124.085 49.9833L123.525 48.6765C123.37 48.7076 123.214 48.7698 123.028 48.8321Z",
    fill: "#393B3D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M120.196 47.4319L118.92 48.0853C119.014 48.272 119.107 48.4587 119.232 48.6454L120.445 47.8675C120.352 47.7431 120.289 47.5875 120.196 47.4319Z",
    fill: "#393B3D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M120.663 48.1476L119.698 49.2054C119.854 49.361 120.009 49.4855 120.196 49.6099L121.067 48.4898C120.943 48.3654 120.787 48.272 120.663 48.1476Z",
    fill: "#393B3D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M122.437 48.8943C122.343 48.8943 122.25 48.8943 122.156 48.8943L122.094 50.3256C122.188 50.3256 122.312 50.3567 122.405 50.3567C122.53 50.3567 122.623 50.3567 122.717 50.3256L122.654 48.8943C122.623 48.8943 122.53 48.8943 122.437 48.8943Z",
    fill: "#393B3D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 48.6454L120.788 49.9833C120.974 50.0766 121.192 50.1389 121.41 50.2011L121.845 48.8321C121.69 48.7698 121.534 48.7076 121.348 48.6454Z",
    fill: "#393B3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3252 -26.4974) rotate(-0.604782) scale(95.7507 132.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_4124",
    x1: 95.8751,
    y1: 40.5312,
    x2: 95.8751,
    y2: 47.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_4124",
    x1: 52.6132,
    y1: 40.5313,
    x2: 52.6132,
    y2: 47.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_4124",
    x1: 134.298,
    y1: 40.5387,
    x2: 134.298,
    y2: 47.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_343_4124",
    x1: 46.9016,
    y1: 37.946,
    x2: 136.393,
    y2: 37.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.9852 6.42287) rotate(-0.0334487) scale(44.129 3.38086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.7843 27.4818) rotate(-0.0620095) scale(61.173 8.68844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.7868 25.328) rotate(-0.0459196) scale(61.178 6.43453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_343_4124",
    x1: 46.9101,
    y1: 17.2942,
    x2: 125.207,
    y2: 17.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4151 7.73531) rotate(-1.65419) scale(5.74805 21.7665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_343_4124",
    x1: 33.3133,
    y1: 17.2942,
    x2: 50.4477,
    y2: 17.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_343_4124",
    x1: 32.6471,
    y1: 37.8569,
    x2: 45.9763,
    y2: 37.8569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9206 27.4818) rotate(-0.416357) scale(9.11078 8.68821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_343_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9206 25.328) rotate(-0.30835) scale(9.11067 6.43444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_343_4124",
    x1: 68.1297,
    y1: 39.1104,
    x2: 68.7787,
    y2: 54.1813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_343_4124",
    x1: 68.4455,
    y1: 51.4122,
    x2: 68.4455,
    y2: 40.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_343_4124",
    x1: 68.4451,
    y1: 50.9586,
    x2: 68.4451,
    y2: 41.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_343_4124",
    x1: 68.4456,
    y1: 42.1688,
    x2: 68.4456,
    y2: 50.6182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_343_4124",
    x1: 68.4453,
    y1: 42.8682,
    x2: 68.4453,
    y2: 52.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_343_4124",
    x1: 68.4456,
    y1: 48.1795,
    x2: 68.4456,
    y2: 44.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_343_4124",
    x1: 68.4449,
    y1: 43.797,
    x2: 68.4449,
    y2: 51.2821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_343_4124",
    x1: 68.4451,
    y1: 45.7258,
    x2: 68.4451,
    y2: 47.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_343_4124",
    x1: 68.4454,
    y1: 45.5258,
    x2: 68.4454,
    y2: 48.1066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_343_4124",
    x1: 122.13,
    y1: 39.1104,
    x2: 122.779,
    y2: 54.1813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_343_4124",
    x1: 122.445,
    y1: 51.4122,
    x2: 122.445,
    y2: 40.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_343_4124",
    x1: 122.445,
    y1: 50.9586,
    x2: 122.445,
    y2: 41.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_343_4124",
    x1: 122.446,
    y1: 42.1688,
    x2: 122.446,
    y2: 50.6182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_343_4124",
    x1: 122.445,
    y1: 42.8682,
    x2: 122.445,
    y2: 52.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_343_4124",
    x1: 122.446,
    y1: 48.1795,
    x2: 122.446,
    y2: 44.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_343_4124",
    x1: 122.445,
    y1: 43.797,
    x2: 122.445,
    y2: 51.2821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_343_4124",
    x1: 122.445,
    y1: 45.7258,
    x2: 122.445,
    y2: 47.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_343_4124",
    x1: 122.445,
    y1: 45.5258,
    x2: 122.445,
    y2: 48.1066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterLifeService);
export default __webpack_public_path__ + "static/media/after_life_service.f2963c8cdf72178896f086fee4474672.svg";
export { ForwardRef as ReactComponent };